<template>
  <div class="main">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          v-for="(item, index) in title"
          :key="index"
          :prop="item.field"
          :label="item.name"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pagesize"
        hide-on-single-page
        :current-page="currentPage1"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      tableData: [],
      title: [],
      loading: true,
      pagesize: 15,
      currentPage1: 1,
      total: 0,
      page: 0,
    };
  },
  created() {
    this.list();
  },

  methods: {
    handleSizeChange(val) {
      this.pagesize = val;

      // this.currentPage1 = 1;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      this.page = val - 1;
      this.list();
      console.log(`当前页: ${val}`, this.currentPage1);
    },
    goPage() {
      this.$router.go(-1);
    },
    list() {
      let obj = {
        search: this.$route.query.src,
        page: this.page,
      };
      let url = "/hrswork_index_data/v1/odd_company_detail/";
      require("post", url, obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data.return_data;
          this.loading = false;
          this.title = res.data.title;
          this.total = res.data.user_count;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.el-table >>> .warning-row {
  background: rgb(240, 196, 196);
}
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
.pay {
  color: rgb(3, 166, 241);
  cursor: pointer;
}
.main >>> .success-row {
  background: rgb(243, 210, 210);
}
.recharge {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/index/odd_company.vue